module.exports = __webpack_public_path__ + "assets/media/evening.074d3947.mp3";